export const defaultNodeData = {
    Organizationname: "",
    Type: "organization",
    Organizationid: "",
    Description: "",
    Organizationlink: "",
    Organizationdetails: {
      Location: "",
      State: "",
      Country: "",
      Latitude: "",
      Longitude: "",
      Pin: "",
    },
    Logo: {
      base64: "",
      height: "",
      width: "",
    },
  };
  export const defaultSubOrgeData = {
    Organizationname: "",
    Type: "Sub-organization",
    Organizationid: "",
    Description: "",
    Organizationlink: "",
    Organizationdetails: {
      Location: "",
      State: "",
      Country: "",
      Latitude: "",
      Longitude: "",
      Pin: "",
    },
    Logo: {
      base64: "",
      height: "",
      width: "",
    },
  };
  
  export const defaultProjectData = {
    Type: "project",
    Description: "",
    Projectname: "",
    Projectdetails: {
      Location: "",
      State: "",
      Country: "",
      Latitude: "",
      Longitude: "",
      Pin: "",
    },
    Logo: {
      base64: "",
      height: "",
      width: "",
    },
  };
  
  export const errorOrgObj = {
    Organizationname: "",
    Type: "",
    Organizationid: "",
    Description: "",
    Organizationlink: "",
    Location: "",
    State: "",
    Country: "",
    Latitude: "",
    Longitude: "",
    Pin: "",
    Logo: {
      base64: "",
      height: "",
      width: "",
    },
  };
  export const errorSubOrgObj = {
    Organizationname: "",
    Type: "",
    Organizationid: "",
    Description: "",
    Organizationlink: "",
    Location: "",
    State: "",
    Country: "",
    Latitude: "",
    Longitude: "",
    Pin: "",
    Logo: {
      base64: "",
      height: "",
      width: "",
    },
  };
  
  export const errorProjObj = {
    Type: "project",
    Description: "",
    Projectname: "",
    Location: "",
    State: "",
    Country: "",
    Latitude: "",
    Longitude: "",
    Pin: "",
  
    Logo: {
      base64: "",
      height: "",
      width: "",
    },
  };
  
  export const URL_REGEX = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[^\s]*)?$/;
  export const LAT_LAN_REGEX = /^[-+]?\d+(\.\d+)?$/;
  export const PIN_REGEX = /^[0-9]{6}$/;
  
  export const validateNodeData = (nodeData, errors, setErrors) => {
    let hasErrors = false;
    let newErrors = { ...errors };
  
    let validations = {};
  
    if (nodeData.Type?.toLowerCase() === "organization") {
      validations = {
        Type: {
          condition: !nodeData.Type,
          message: "Type is required.",
        },
        Organizationname: {
          condition: !/^(?! )[A-Za-z0-9 _-]{5,30}(?<! )$/.test(nodeData.Organizationname.trim()),
          message:
            "Organization Name must be 5-30 characters long and can include letters, numbers, hyphens, underscores, and spaces. No leading or trailing spaces.",
        },
        Description: {
          condition: nodeData.Description && !/^(|.{20,100})$/.test(nodeData.Description.trim()),
          message:
            "Description must be 20-100 characters long. No leading or trailing spaces.",
        },
        Location: {
          condition:
            !nodeData.Organizationdetails.Location ||
            !/^(?! )[A-Za-z\s\-]{3,50}(?<! )$/.test(nodeData.Organizationdetails.Location.trim()),
          message:
            "Location must be 3-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        State: {
          condition:
            !nodeData.Organizationdetails.State ||
            !/^(?! )[A-Za-z\s\-]{2,50}(?<! )$/.test(nodeData.Organizationdetails.State.trim()),
          message:
            "State must be 2-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        Country: {
          condition:
            !nodeData.Organizationdetails.Country ||
            !/^(?! )[A-Za-z\s\-]{3,50}(?<! )$/.test(nodeData.Organizationdetails.Country.trim()),
          message:
            "Country must be 3-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        // Latitude: {
        //   condition:
        //     isNaN(parseFloat(nodeData.Organizationdetails.Latitude)) ||
        //     parseFloat(nodeData.Organizationdetails.Latitude) < -90 ||
        //     parseFloat(nodeData.Organizationdetails.Latitude) > 90,
        //   message: "Latitude must be a number between -90 and 90.",
        // },
        // Longitude: {
        //   condition:
        //     isNaN(parseFloat(nodeData.Organizationdetails.Longitude)) ||
        //     parseFloat(nodeData.Organizationdetails.Longitude) < -180 ||
        //     parseFloat(nodeData.Organizationdetails.Longitude) > 180,
        //   message: "Longitude must be a number between -180 and 180.",
        // },
        Pin: {
          condition:
            !nodeData.Organizationdetails.Pin ||
            !/^[A-Za-z0-9\- ]{3,10}$/.test(nodeData.Organizationdetails.Pin.trim()),
          message:
            "PIN Code must be 3-10 characters long and can include letters, numbers, spaces, and hyphens. No leading or trailing spaces.",
        },
        Organizationlink: {
          condition: nodeData.Organizationlink && !/^(https?:\/\/)([\w.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i.test(nodeData.Organizationlink),
          message:
            "Organization Link must be a valid URL starting with http:// or https://.",
        },
        LogoHeight: {
          condition:
            nodeData.Logo.height &&
            (isNaN(parseInt(nodeData.Logo.height, 10)) ||
              parseInt(nodeData.Logo.height, 10) < 20 ||
              parseInt(nodeData.Logo.height, 10) > 40),
          message: "Logo Height must be a number between 20 and 40.",
        },
        LogoWidth: {
          condition:
            nodeData.Logo.width &&
            (isNaN(parseInt(nodeData.Logo.width, 10)) ||
              parseInt(nodeData.Logo.width, 10) < 20 ||
              parseInt(nodeData.Logo.width, 10) > 40),
          message: "Logo Width must be a number between 20 and 40.",
        },
      };
    }
    else if (nodeData.Type?.toLowerCase() === "sub-organization") {
      validations = {
        Type: {
          condition: !nodeData.Type,
          message: "Type is required.",
        },
        Organizationname: {
          condition: !/^(?! )[A-Za-z0-9 _-]{5,30}(?<! )$/.test(nodeData.Organizationname.trim()),
          message:
            "Organization Name must be 5-30 characters long and can include letters, numbers, hyphens, underscores, and spaces. No leading or trailing spaces.",
        },
        Description: {
          condition: nodeData.Description && !/^(|.{20,100})$/.test(nodeData.Description.trim()),
          message:
            "Description must be 20-100 characters long. No leading or trailing spaces.",
        },
        Location: {
          condition:
            !nodeData.Organizationdetails.Location ||
            !/^(?! )[A-Za-z\s\-]{3,50}(?<! )$/.test(nodeData.Organizationdetails.Location.trim()),
          message:
            "Location must be 3-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        State: {
          condition:
            !nodeData.Organizationdetails.State ||
            !/^(?! )[A-Za-z\s\-]{2,50}(?<! )$/.test(nodeData.Organizationdetails.State.trim()),
          message:
            "State must be 2-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        Country: {
          condition:
            !nodeData.Organizationdetails.Country ||
            !/^(?! )[A-Za-z\s\-]{3,50}(?<! )$/.test(nodeData.Organizationdetails.Country.trim()),
          message:
            "Country must be 3-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        Latitude: {
          condition:
            isNaN(parseFloat(nodeData.Organizationdetails.Latitude)) ||
            parseFloat(nodeData.Organizationdetails.Latitude) < -90 ||
            parseFloat(nodeData.Organizationdetails.Latitude) > 90,
          message: "Latitude must be a number between -90 and 90.",
        },
        Longitude: {
          condition:
            isNaN(parseFloat(nodeData.Organizationdetails.Longitude)) ||
            parseFloat(nodeData.Organizationdetails.Longitude) < -180 ||
            parseFloat(nodeData.Organizationdetails.Longitude) > 180,
          message: "Longitude must be a number between -180 and 180.",
        },
        Pin: {
          condition:
            !nodeData.Organizationdetails.Pin ||
            !/^[A-Za-z0-9\- ]{3,10}$/.test(nodeData.Organizationdetails.Pin.trim()),
          message:
            "PIN Code must be 3-10 characters long and can include letters, numbers, spaces, and hyphens. No leading or trailing spaces.",
        },
        Organizationlink: {
          condition: nodeData.Organizationlink && !/^(https?:\/\/)([\w.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i.test(nodeData.Organizationlink),
          message:
            "Organization Link must be a valid URL starting with http:// or https://.",
        },
        LogoHeight: {
          condition:
            nodeData.Logo.height &&
            (isNaN(parseInt(nodeData.Logo.height, 10)) ||
              parseInt(nodeData.Logo.height, 10) < 20 ||
              parseInt(nodeData.Logo.height, 10) > 40),
          message: "Logo Height must be a number between 20 and 40.",
        },
        LogoWidth: {
          condition:
            nodeData.Logo.width &&
            (isNaN(parseInt(nodeData.Logo.width, 10)) ||
              parseInt(nodeData.Logo.width, 10) < 20 ||
              parseInt(nodeData.Logo.width, 10) > 40),
          message: "Logo Width must be a number between 20 and 40.",
        },
      };
    }
    else if (nodeData.Type?.toLowerCase() === "project") {
      validations = {
        Type: {
          condition: !nodeData.Type,
          message: "Type is required.",
        },
        Projectname: {
          condition: !/^(?! )[A-Za-z0-9 _-]{5,30}(?<! )$/.test(nodeData.Projectname.trim()),
          message:
            "Project Name must be 5-30 characters long and can include letters, numbers, hyphens, underscores, and spaces. No leading or trailing spaces.",
        },
        Description: {
          condition: nodeData.Description && !/^(|.{20,100})$/.test(nodeData.Description.trim()),
          message:
            "Description must be 20-100 characters long. No leading or trailing spaces.",
        },
        Location: {
          condition:
            !nodeData.Projectdetails.Location ||
            !/^(?! )[A-Za-z\s\-]{3,50}(?<! )$/.test(nodeData.Projectdetails.Location.trim()),
          message:
            "Location must be 3-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        State: {
          condition:
            !nodeData.Projectdetails.State ||
            !/^(?! )[A-Za-z\s\-]{3,50}(?<! )$/.test(nodeData.Projectdetails.State.trim()),
          message:
            "State must be 3-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        Country: {
          condition:
            !nodeData.Projectdetails.Country ||
            !/^(?! )[A-Za-z\s\-]{3,50}(?<! )$/.test(nodeData.Projectdetails.Country.trim()),
          message:
            "Country must be 3-50 characters long and can include letters, spaces, and hyphens. No leading or trailing spaces.",
        },
        Latitude: {
          condition:
            isNaN(parseFloat(nodeData.Projectdetails.Latitude)) ||
            parseFloat(nodeData.Projectdetails.Latitude) < -90 ||
            parseFloat(nodeData.Projectdetails.Latitude) > 90,
          message: "Latitude must be a number between -90 and 90.",
        },
        Longitude: {
          condition:
            isNaN(parseFloat(nodeData.Projectdetails.Longitude)) ||
            parseFloat(nodeData.Projectdetails.Longitude) < -180 ||
            parseFloat(nodeData.Projectdetails.Longitude) > 180,
          message: "Longitude must be a number between -180 and 180.",
        },
        Pin: {
          condition:
            !nodeData.Projectdetails.Pin ||
            !/^[A-Za-z0-9\- ]{3,10}$/.test(nodeData.Projectdetails.Pin.trim()),
          message:
            "PIN Code must be 3-10 characters long and can include letters, numbers, spaces, and hyphens. No leading or trailing spaces.",
        },     
        LogoHeight: {
          condition:
            nodeData.Logo.height &&
            (isNaN(parseInt(nodeData.Logo.height, 10)) ||
              parseInt(nodeData.Logo.height, 10) < 20 ||
              parseInt(nodeData.Logo.height, 10) > 40),
          message: "Logo Height must be a number between 20 and 40.",
        },
        LogoWidth: {
          condition: nodeData.Logo.width &&
            (isNaN(parseInt(nodeData.Logo.width, 10)) ||
              parseInt(nodeData.Logo.width, 10) < 20 ||
              parseInt(nodeData.Logo.width, 10) > 40),
          message: "Logo Width must be a number between 20 and 40.",
        },
      };
    }
  
    for (let field in validations) {
      if (validations[field].condition) {
        newErrors[field] = validations[field].message;
        hasErrors = true;
      } else {
        newErrors[field] = "";
      }
    }
  
    setErrors(newErrors);

    return hasErrors;
  };